/**
 * AchievementToast — aviso celebratorio al desbloquear un trofeo por acción.
 * "¡Has desbloqueado el trofeo de los saludos! 👋"
 *
 * Muestra una cola (por si se desbloquean varios a la vez); cada tarjeta se
 * autocierra a los ~6s o al hacer clic. Español (el estudiante ve español).
 */

import { useEffect } from 'react';
import { TrophyMedal } from './TrophyMedal';
import { ActionAchievement } from '../../config/actionAchievements';
import './AchievementToast.css';

interface AchievementToastProps {
  queue: ActionAchievement[];
  onDismiss: (id: string) => void;
}

export function AchievementToast({ queue, onDismiss }: AchievementToastProps) {
  if (queue.length === 0) return null;
  return (
    <div className="achievement-toast-stack" role="status" aria-live="polite">
      {queue.map((a) => (
        <ToastCard key={a.id} achievement={a} onDismiss={() => onDismiss(a.id)} />
      ))}
    </div>
  );
}

function ToastCard({
  achievement,
  onDismiss,
}: {
  achievement: ActionAchievement;
  onDismiss: () => void;
}) {
  useEffect(() => {
    const t = window.setTimeout(onDismiss, 6000);
    return () => window.clearTimeout(t);
  }, [onDismiss]);

  return (
    <button className="achievement-toast" onClick={onDismiss} type="button">
      <TrophyMedal trophyId={achievement.id} emoji={achievement.emoji} className="achievement-toast-emoji" />
      <span className="achievement-toast-text">
        {/* El trofeo celebra un acto EN FRANCÉS → nombre en francés (enseña),
            explicación en español (el estudiante ve UI en español). */}
        <span className="achievement-toast-eyebrow">Trophée débloqué !</span>
        <span className="achievement-toast-title">{achievement.titleFr}</span>
        <span className="achievement-toast-blurb">{achievement.blurb}</span>
      </span>
      <span className="achievement-toast-spark" aria-hidden="true">✨</span>
    </button>
  );
}

export default AchievementToast;
